import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { getOpeningHours, getRestaurantDetails } from '../../api';
import { FaMinus } from 'react-icons/fa6';
import { FaPlus } from 'react-icons/fa6';
import {
  Box,
  Grid,
  InputAdornment,
  InputLabel,
  TextField,
  Typography,
  IconButton,
  Popover,
  ListItemButton,
  LinearProgress,
  Button,
  SwipeableDrawer,
  ThemeProvider,
} from '@mui/material';
import { ImWhatsapp } from 'react-icons/im';
import logo from '../../Assets/logo/logo.svg';
import logogrey from '../../Assets/logo/logo-icon-grey.svg';
import BounceLoader from 'react-spinners/BounceLoader';
import Calender from '../../Main/Components/Common/Calendar';
import { RiArrowDropDownFill } from 'react-icons/ri';
import { IoArrowBackCircleOutline } from 'react-icons/io5';
import GiftCarousel from '../../Main/Components/Common/GiftCarousel';
import { BsCalendar2CheckFill } from 'react-icons/bs';
import { BsFillPeopleFill } from 'react-icons/bs';
import { GoClockFill } from 'react-icons/go';
import { useSnackbar } from 'notistack';
import { useSelector } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import SEO from '../../utils/SEO';
import { PiPicnicTableLight } from 'react-icons/pi';
import { Theme, ThemeTerrace, ThemeForno } from '../../Themes';
import TodayExperience from './TodayExperience';
import {
  daily_events,
  isForno_Color,
  isReisty_Color,
  isTerrace_Color,
  formatDate,
} from './WidgetConfig';
import { IoMdGift } from 'react-icons/io';
import anime from '../../Assets/anime/gift.json';
import Lottie from 'react-lottie';
import FoodCard from './Components/FoodCard';
import reserved from '../../Assets/images/reservered.png';

const GiftWidget = () => {
  const dateObject = new Date();
  const { name } = useParams();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const toDate = dateObject.toISOString().split('T')[0];

  const [loading, setLoading] = useState(false);

  const [date, setDate] = useState(toDate);
  const [restaurant, setRestaurant] = useState(null);
  const [activeStep, setActiveStep] = useState(0);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openingHours, setOpeningHours] = useState(null);
  const [selectedTime, setSelectedTime] = useState('');
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [selectedFloor, setSelectedFloor] = useState(null);
  const [pointSelected, setPointSelected] = useState(null);
  const [guest, setGuest] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [timeError, setTimeError] = useState(
    '  No Available Time for the selected date',
  );
  const [fullyBooked, setFullyBooked] = useState(false);

  const [currentTheme, setCurrentTheme] = useState(Theme);
  const [currentColor, setCurrentColor] = useState(isReisty_Color);

  // =======Restaurant config========
  const EVENTFUL = name === 'mercury-lagos';
  const IS_TERRACE = name === 'the-terrace-lagos';
  const IS_FORNO = name === 'forno-lagos';
  const IS_SHIRO = name === 'shiro';
  const IS_HARDROCK = name === 'hard-rock-cafe';

  useEffect(() => {
    if (IS_TERRACE) {
      setCurrentColor(isTerrace_Color);
      setCurrentTheme(ThemeTerrace);
    } else if (IS_FORNO) {
      setCurrentColor(isForno_Color);
      setCurrentTheme(ThemeForno);
    } else {
      setCurrentColor(isReisty_Color);
      setCurrentTheme(Theme);
    }
  }, [name]);

  // const isReisty = name === "reisty-bistro";
  // =======Restaurant config========

  const open = Boolean(anchorEl);
  const pid = open ? 'simple-popover' : undefined;

  const handleClose = () => {
    setAnchorEl(null);
  };

  const toggleDrawer = (newOpen) => {
    setOpenDrawer(newOpen);
  };

  const override = {
    display: 'block',
    margin: 'auto',
    borderColor: currentColor.primary,
  };

  const handleAlert = (variant, message) => {
    enqueueSnackbar(message, { variant });
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleSelectTime = (time, point) => {
    setSelectedTime(time);
    setPointSelected(point);
  };

  const handleGetRestaurantDetails = async () => {
    setLoading(true);
    await getRestaurantDetails(name)
      .then((res) => {
        setLoading(false);
        // console.log(res);
        if (res?.data?.status) {
          setRestaurant(res?.data?.result[0]);
          setSelectedTime(null);
          setSelectedFloor(res.data?.result[0]?.FloorPlans[0]?.Id);
        }
      })
      .catch((err) => {
        setLoading(false);
        // console.log(err);
      });
  };

  const [deposit, setDeposit] = useState(0);

  const handleGetTime = async () => {
    setIsLoading(true);
    setOpeningHours(null);
    await getOpeningHours(restaurant?.RestaurantId, date, guest, selectedFloor)
      .then((res) => {
        setIsLoading(false);

        if (res?.data?.status) {
          setOpeningHours(res?.data?.result[0]?.GroupedTime);
          setDeposit(res?.data?.result[0]?.ReservationDeposit);
          if (res?.data?.success_message === 'Fully booked') {
            setFullyBooked(true);
          } else {
            setFullyBooked(false);
          }
        } else {
          setOpeningHours(null);
          if (res?.data?.error_message === 'Fully booked') {
            setFullyBooked(true);
          } else {
            setFullyBooked(false);
            handleAlert('error', `${res?.data?.error_message}`);

            setTimeError(res?.data?.error_message);
          }
        }
      })
      .catch((err) => {
        setSelectedTime(null);

        handleAlert('error', `${err?.message}`);

        setIsLoading(false);
        setOpeningHours(null);
      });
  };

  useEffect(() => {
    setDate(toDate);
    handleGetRestaurantDetails();
  }, []);

  useEffect(() => {
    setSelectedTime(selectedTime);
  }, [selectedTime]);

  useEffect(() => {
    if (restaurant?.RestaurantId && guest > 0) {
      handleGetTime();
    }
  }, [name, date, restaurant, guest, selectedFloor]);


  const [selectedGift, setSelectedGift] = useState(null);

  const handleClickGift = (gift) => {
    setSelectedGift(gift);
     navigate(`/gift-reservation/details?gift=${gift?.title}&gift_price=${gift?.price}&name=${name}`)
                                
  };

  const guestUrl = `/gift-reservation/details?gift=${selectedGift?.title}&gift_price=${selectedGift?.price}`;

  const userUrl = `/gift-reservation/details?restaurantName=${name}&guest=${guest}&time=${selectedTime}&date=${date}&deposit=${
    deposit
  }&floor=${selectedFloor}&pointValue=${
    pointSelected?.Value || null
  }&point_id=${pointSelected?.Id || null}&gift=${selectedGift?.title}&gift_price=${selectedGift?.price}`;

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: anime,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };


  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <SEO
        title={`${name} | Make a Reservation`}
        name="Reisty"
        type="article"
      />
      <ThemeProvider theme={currentTheme}>
        <Box
          className="hide_scrollbar"
          sx={{
            backgroundColor: currentColor.background,
            minHeight: '100vh',
            backgroundSize: 'contain',
            boxSizing: 'border-box',

            width: '100vw',
          }}
        >
          <Box
            className="hide_scrollbar"
            sx={{
              margin: '0 auto',
              width: { xl: '30%', lg: '40%', md: '50%', sm: '65%', xs: '100%' },
              bgcolor: currentColor.mainbg,
              minHeight: '100vh',
              boxSizing: 'border-box',
              pb: 4,
            }}
          >
            {loading ? (
              <>
                <Box
                  sx={{
                    height: '100vh',
                    display: 'grid',
                    placeItems: 'center',
                  }}
                >
                  <BounceLoader
                    color={currentColor.primary}
                    loading={true}
                    cssOverride={override}
                    size={100}
                    aria-label="Loading Spinner"
                    data-testid="loader"
                  />
                </Box>
              </>
            ) : (
              <>
                <Box
                  sx={{
                    pt: 3,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                  }}
                >
                  <img
                    src={
                      IS_TERRACE || IS_FORNO || IS_SHIRO || IS_HARDROCK
                        ? restaurant?.Logo
                        : logo
                    }
                    width={70}
                  />
                  <Box
                    sx={{
                      mt: 2,
                      display: 'flex',
                      alignItems: 'center',
                      columnGap: 2,
                      px: 3,
                      flexDirection: 'column',
                    }}
                  >
                    <Typography
                      sx={{
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis',
                        maxWidth: '100%',
                        overflow: 'hidden',
                      }}
                    >
                      Gift a Reservation at
                      <span
                        style={{ textTransform: 'uppercase', fontWeight: 700 }}
                      >
                        {' '}
                        {name}
                      </span>
                    </Typography>
                    <Typography
                      sx={{
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis',
                        maxWidth: '100%',
                        overflow: 'hidden',
                        fontSize: '12px',
                        mt: 0.5,
                      }}
                    >
                      Opens from{' '}
                      <b> {restaurant?.OpenFrom?.substring(0, 8) || '--'}</b>
                    </Typography>
                    {/* <OpenTag hoursString={restaurant?.OpenFrom} /> */}
                  </Box>
                  <Box sx={{ mt: 2, width: '100%' }}>
                    <GiftCarousel
                      images={restaurant?.Photos}
                      description={restaurant?.Description}
                      title={restaurant?.RestaurantName}
                      defaultOptions={defaultOptions}
                    />
                  </Box>
                </Box>
                <Box
                  className="hide_scrollbar"
                  sx={{
                    margin: '0 auto',
                    width: '90%',
                    mt: 3,
                    overflow: 'scroll',
                  }}
                >
                  {activeStep === 1 && (
                    <>
                      <Grid container spacing={2}>
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                          <Box>
                            <InputLabel>Number of Guest(s)</InputLabel>
                            <TextField
                              value={guest}
                              onChange={(e) => setGuest(e.target.value)}
                              type="number"
                              margin="dense"
                              fullWidth
                              error={!guest}
                              helperText={
                                !guest && 'please enter a valid guest size'
                              }
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <IconButton
                                      disabled={isLoading || guest < 1}
                                      onClick={() => {
                                        if (guest > 1) {
                                          setGuest(guest - 1);
                                        }
                                      }}
                                      sx={{
                                        border: '1px solid ',
                                        borderRadius: '5px',
                                      }}
                                    >
                                      <FaMinus style={{ fontSize: '12px' }} />
                                    </IconButton>
                                    <IconButton
                                      onClick={() =>
                                        setGuest((prev) => parseFloat(prev) + 1)
                                      }
                                      disabled={
                                        (guest > 8 && IS_FORNO) || isLoading
                                      }
                                      sx={{
                                        border: '1px solid ',
                                        borderRadius: '5px',
                                        ml: 1,
                                      }}
                                    >
                                      <FaPlus style={{ fontSize: '12px' }} />
                                    </IconButton>
                                  </InputAdornment>
                                ),
                                style: {
                                  fontSize: '12px',
                                  borderRadius: '8px',
                                },
                                disabled: isLoading || guest < 0,
                                inputMode: 'numeric',
                                pattern: '[0-9]*',
                              }}
                            />
                          </Box>
                        </Grid>
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                          <Box>
                            <InputLabel>Date</InputLabel>
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                width: '100%',
                                border: '1px solid #d7d7d7',
                                px: 2,
                                mt: 1,
                                pb: 0.5,
                                boxSizing: 'border-box',
                                borderRadius: '8px',
                                height: '50px',
                              }}
                              aria-describedby={pid}
                              onClick={handleClick}
                            >
                              <Box>
                                <Typography
                                  sx={{ fontWeight: 500, fontSize: '12px' }}
                                >
                                  {formatDate(date)}
                                </Typography>
                              </Box>
                              <RiArrowDropDownFill
                                style={{ fontSize: '20px' }}
                              />
                            </Box>
                          </Box>
                        </Grid>
                      </Grid>

                      <>
                        <Box sx={{ mt: 2, width: '100%' }}>
                          <Typography sx={{ textAlign: 'center' }}>
                            Select Seating Area
                          </Typography>
                          <Box
                            sx={{
                              mt: 1,
                              display: 'flex',
                              columnGap: 2,
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              flexWrap: 'wrap',
                              px: 1,
                            }}
                          >
                            {restaurant?.FloorPlans?.map((floor, index) => (
                              <ListItemButton
                                key={index}
                                onClick={() => {
                                  setSelectedFloor(floor?.Id);
                                  setSelectedTime(null);
                                }}
                                selected={selectedFloor === floor?.Id}
                                sx={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  mt: 0.8,
                                  width: '47%',
                                  border: '0.5px solid #d3d3d3',
                                  bgcolor: '#fff',
                                  '&.Mui-selected': {
                                    border: '1px solid',
                                    borderColor: currentColor.primary,
                                  },
                                }}
                              >
                                <PiPicnicTableLight
                                  style={{
                                    fontSize: '50px',
                                    color:
                                      selectedFloor === floor?.Id && IS_TERRACE
                                        ? '#013709'
                                        : '#bc172f',
                                  }}
                                />
                                <Typography
                                  sx={{
                                    mt: 1,
                                    fontWeight: 500,
                                    color:
                                      selectedFloor === floor?.Id &&
                                      'primary.main',
                                  }}
                                >
                                  {floor?.Name}
                                </Typography>
                              </ListItemButton>
                            ))}
                          </Box>
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Box>
                              <InputLabel sx={{ mt: 2 }}>Time</InputLabel>
                              <Grid container spacing={2} sx={{ mt: 0 }}>
                                {isLoading && (
                                  <Box align="center" sx={{ width: '100%' }}>
                                    <LinearProgress sx={{ width: '50%' }} />
                                    <Typography
                                      sx={{
                                        color: 'primary.main',
                                        fontSize: '10px',
                                      }}
                                    >
                                      Checking for Available Time...
                                    </Typography>
                                  </Box>
                                )}

                                {!openingHours ||
                                openingHours.length === 0 ||
                                (openingHours[0].length === 0 &&
                                  openingHours[1]?.length === 0) ? (
                                  <>
                                    {!isLoading && (
                                      <>
                                        <Box
                                          sx={{ p: 1, width: '100%', mt: 1 }}
                                        >
                                          {/* <Typography
                                              sx={{
                                                textAlign: "center",
                                                fontWeight: 600,
                                                color: currentColor.primary,
                                              }}
                                            >
                                              {timeError}
                                            </Typography> */}
                                          {guest > 9 && IS_FORNO ? (
                                            <>
                                              <Typography
                                                sx={{
                                                  textAlign: 'center',
                                                  fontWeight: 300,
                                                  fontSize: '12px',
                                                }}
                                              >
                                                Please contact the restaurant to
                                                confirm your reservation
                                              </Typography>
                                              <a
                                                href="https://wa.me/2349161178000"
                                                target="_blank"
                                              >
                                                <Box
                                                  sx={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    columnGap: 2,
                                                    alignItems: 'center',
                                                    mt: 1,
                                                  }}
                                                >
                                                  <Typography>
                                                    Chat us here
                                                  </Typography>
                                                  <ImWhatsapp />
                                                </Box>
                                              </a>
                                            </>
                                          ) : (
                                            <Typography
                                              sx={{
                                                textAlign: 'center',
                                                fontWeight: 300,
                                                fontSize: '12px',
                                              }}
                                            >
                                              <Typography
                                                sx={{
                                                  textAlign: 'center',
                                                  fontWeight: 600,
                                                  color: currentColor.primary,
                                                }}
                                              >
                                                {timeError}
                                              </Typography>
                                              You can try selecting another date
                                              or guest size
                                            </Typography>
                                          )}
                                        </Box>
                                      </>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {fullyBooked ? (
                                      <>
                                        {openingHours &&
                                          openingHours[0]?.map(
                                            (time, index) => (
                                              <Grid
                                                item
                                                lg={3}
                                                md={3}
                                                sm={4}
                                                xs={4}
                                                key={index}
                                              >
                                                <ListItemButton
                                                  key={index}
                                                  onClick={() => {
                                                    handleSelectTime(
                                                      time?.Time,
                                                      time.ReservationPoint,
                                                    );
                                                  }}
                                                  selected={
                                                    selectedTime === time?.Time
                                                  }
                                                  sx={{
                                                    border: '1px solid #d7d7d7',
                                                    borderRadius: '8px',
                                                    bgcolor:
                                                      currentColor.primary,
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    color: '#fff',
                                                    justifyContent: 'center',
                                                    '&.Mui-selected, &:hover, &:focus':
                                                      {
                                                        border: '1px solid',
                                                        borderColor:
                                                          currentColor.primary,
                                                        bgcolor:
                                                          currentColor.primary,
                                                        color:
                                                          currentColor.mainbg,
                                                      },
                                                    '&:hover': {
                                                      border: '1px solid',
                                                      borderColor:
                                                        currentColor.primary,
                                                      bgcolor:
                                                        currentColor.primary,
                                                      color:
                                                        currentColor.mainbg,
                                                    },
                                                  }}
                                                >
                                                  <Typography
                                                    sx={{
                                                      fontSize: '10px',
                                                      whiteSpace: 'nowrap',
                                                    }}
                                                  >
                                                    {' '}
                                                    {time?.Time}
                                                  </Typography>
                                                  <Typography
                                                    sx={{
                                                      fontSize: '8px',
                                                      whiteSpace: 'nowrap',
                                                      mt: -1,
                                                    }}
                                                  >
                                                    {' '}
                                                    Reserved
                                                  </Typography>
                                                  <Typography
                                                    sx={{
                                                      fontSize: '8px',
                                                      whiteSpace: 'nowrap',
                                                      mt: -1,
                                                    }}
                                                  >
                                                    {' '}
                                                    Join Waitlist
                                                  </Typography>
                                                </ListItemButton>
                                                {time?.ReservationPoint && (
                                                  <Typography
                                                    sx={{
                                                      textAlign: 'center',
                                                      fontSize: '10px',
                                                      color: 'primary.main',
                                                      fontWeight: 700,
                                                    }}
                                                  >
                                                    +
                                                    {
                                                      time?.ReservationPoint
                                                        ?.Value
                                                    }
                                                    pts
                                                  </Typography>
                                                )}
                                              </Grid>
                                            ),
                                          )}
                                        {openingHours &&
                                          openingHours[1]?.map(
                                            (time, index) => (
                                              <Grid
                                                item
                                                lg={3}
                                                md={3}
                                                sm={4}
                                                xs={4}
                                                key={index}
                                              >
                                                <ListItemButton
                                                  key={index}
                                                  onClick={() => {
                                                    handleSelectTime(
                                                      time?.Time,
                                                      time.ReservationPoint,
                                                    );
                                                  }}
                                                  selected={
                                                    selectedTime === time?.Time
                                                  }
                                                  sx={{
                                                    border: '1px solid #d7d7d7',
                                                    borderRadius: '8px',
                                                    bgcolor:
                                                      currentColor.primary,
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    color: '#fff',
                                                    justifyContent: 'center',
                                                    '&.Mui-selected, &:hover, &:focus':
                                                      {
                                                        border: '1px solid ',
                                                        borderColor:
                                                          currentColor.primary,
                                                        bgcolor:
                                                          currentColor.primary,
                                                        color:
                                                          currentColor.mainbg,
                                                      },
                                                    ' &:hover': {
                                                      border: '1px solid ',
                                                      borderColor:
                                                        currentColor.primary,
                                                      bgcolor:
                                                        currentColor.primary,
                                                      color:
                                                        currentColor.mainbg,
                                                    },
                                                  }}
                                                >
                                                  <Typography
                                                    sx={{
                                                      fontSize: '10px',
                                                      whiteSpace: 'nowrap',
                                                    }}
                                                  >
                                                    {' '}
                                                    {time?.Time}
                                                  </Typography>
                                                  <Typography
                                                    sx={{
                                                      fontSize: '8px',
                                                      whiteSpace: 'nowrap',
                                                      mt: -1,
                                                    }}
                                                  >
                                                    {' '}
                                                    Reserved
                                                  </Typography>
                                                  <Typography
                                                    sx={{
                                                      fontSize: '8px',
                                                      whiteSpace: 'nowrap',
                                                      mt: -1,
                                                    }}
                                                  >
                                                    {' '}
                                                    Join Waitlist
                                                  </Typography>
                                                </ListItemButton>
                                                {time?.ReservationPoint && (
                                                  <Typography
                                                    sx={{
                                                      textAlign: 'center',
                                                      fontSize: '10px',
                                                      color: 'primary.main',
                                                      fontWeight: 700,
                                                    }}
                                                  >
                                                    +
                                                    {
                                                      time?.ReservationPoint
                                                        ?.Value
                                                    }
                                                    pts
                                                  </Typography>
                                                )}
                                              </Grid>
                                            ),
                                          )}
                                      </>
                                    ) : (
                                      <>
                                        {openingHours &&
                                          openingHours[0]?.map(
                                            (time, index) => {
                                              const IsAvailable =
                                                time?.IsAvailable;
                                              return (
                                                <Grid
                                                  item
                                                  lg={3}
                                                  md={3}
                                                  sm={4}
                                                  xs={4}
                                                  key={index}
                                                >
                                                  {IsAvailable ? (
                                                    <>
                                                      <ListItemButton
                                                        disabled={!IsAvailable}
                                                        onClick={() => {
                                                          handleSelectTime(
                                                            time?.Time,
                                                            time.ReservationPoint,
                                                          );
                                                        }}
                                                        selected={
                                                          selectedTime ===
                                                          time?.Time
                                                        }
                                                        sx={{
                                                          border:
                                                            '1px solid #d7d7d7',
                                                          borderRadius: '8px',
                                                          '&.Mui-selected, &:hover, &.Mui-focusVisible':
                                                            {
                                                              border:
                                                                '1px solid',
                                                              borderColor:
                                                                currentColor.primary,
                                                              bgcolor:
                                                                currentColor.primary,
                                                              color:
                                                                currentColor.mainbg,
                                                            },
                                                        }}
                                                      >
                                                        <Typography
                                                          sx={{
                                                            fontSize: '12px',
                                                            whiteSpace:
                                                              'nowrap',
                                                          }}
                                                        >
                                                          {' '}
                                                          {time?.Time}
                                                        </Typography>
                                                      </ListItemButton>
                                                      {time?.ReservationPoint && (
                                                        <Typography
                                                          sx={{
                                                            textAlign: 'center',
                                                            fontSize: '10px',
                                                            color:
                                                              'primary.main',
                                                            fontWeight: 700,
                                                          }}
                                                        >
                                                          +
                                                          {
                                                            time
                                                              ?.ReservationPoint
                                                              ?.Value
                                                          }
                                                          pts
                                                        </Typography>
                                                      )}
                                                    </>
                                                  ) : (
                                                    <ListItemButton
                                                      disabled
                                                      onClick={() => {
                                                        handleSelectTime(
                                                          time?.Time,
                                                          time.ReservationPoint,
                                                        );
                                                      }}
                                                      selected={
                                                        selectedTime ===
                                                        time?.Time
                                                      }
                                                      sx={{
                                                        border:
                                                          '1px solid #d7d7d7',
                                                        borderRadius: '8px',
                                                        // bgcolor: "#BC172F",
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'center',
                                                        // color: "#fff",
                                                        justifyContent:
                                                          'center',
                                                        '&:hover': {
                                                          borderColor:
                                                            currentColor.primary,
                                                        },

                                                        // Selected style (default and hover)
                                                        '&.Mui-selected': {
                                                          borderColor:
                                                            currentColor.primary,
                                                          backgroundColor:
                                                            currentColor.primary,
                                                          color:
                                                            currentColor.mainbg,

                                                          // preserve on hover
                                                          '&:hover': {
                                                            backgroundColor:
                                                              currentColor.primary,
                                                            color:
                                                              currentColor.mainbg,
                                                            borderColor:
                                                              currentColor.primary,
                                                          },
                                                        },
                                                      }}
                                                    >
                                                      <Typography
                                                        sx={{
                                                          fontSize: '10px',
                                                          whiteSpace: 'nowrap',
                                                        }}
                                                      >
                                                        {' '}
                                                        {time?.Time}
                                                      </Typography>
                                                    </ListItemButton>
                                                  )}
                                                </Grid>
                                              );
                                            },
                                          )}
                                        {openingHours &&
                                          openingHours[1]?.map(
                                            (time, index) => {
                                              const IsAvailable =
                                                time?.IsAvailable;
                                              return (
                                                <Grid
                                                  item
                                                  lg={3}
                                                  md={3}
                                                  sm={4}
                                                  xs={4}
                                                  key={index}
                                                >
                                                  {IsAvailable ? (
                                                    <>
                                                      <ListItemButton
                                                        disabled={!IsAvailable}
                                                        onClick={() => {
                                                          handleSelectTime(
                                                            time?.Time,
                                                            time.ReservationPoint,
                                                          );
                                                        }}
                                                        selected={
                                                          selectedTime ===
                                                          time?.Time
                                                        }
                                                        sx={{
                                                          border:
                                                            '1px solid #d7d7d7',
                                                          borderRadius: '8px',
                                                          '&:hover': {
                                                            borderColor:
                                                              currentColor.primary,
                                                          },

                                                          // Selected style (default and hover)
                                                          '&.Mui-selected': {
                                                            borderColor:
                                                              currentColor.primary,
                                                            backgroundColor:
                                                              currentColor.primary,
                                                            color:
                                                              currentColor.mainbg,

                                                            // preserve on hover
                                                            '&:hover': {
                                                              backgroundColor:
                                                                currentColor.primary,
                                                              color:
                                                                currentColor.mainbg,
                                                              borderColor:
                                                                currentColor.primary,
                                                            },
                                                          },
                                                        }}
                                                      >
                                                        <Typography
                                                          sx={{
                                                            fontSize: '12px',
                                                            whiteSpace:
                                                              'nowrap',
                                                          }}
                                                        >
                                                          {' '}
                                                          {time?.Time}
                                                        </Typography>
                                                      </ListItemButton>
                                                      {time?.ReservationPoint && (
                                                        <Typography
                                                          sx={{
                                                            textAlign: 'center',
                                                            fontSize: '10px',
                                                            color:
                                                              'primary.main',
                                                            fontWeight: 700,
                                                          }}
                                                        >
                                                          +
                                                          {
                                                            time
                                                              ?.ReservationPoint
                                                              ?.Value
                                                          }
                                                          pts
                                                        </Typography>
                                                      )}
                                                    </>
                                                  ) : (
                                                    <ListItemButton
                                                      selected={
                                                        selectedTime ===
                                                        time?.Time
                                                      }
                                                      disabled
                                                      sx={{
                                                        border:
                                                          '1px solid #d7d7d7',
                                                        borderRadius: '8px',

                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'center',
                                                        // color: "#fff",
                                                        justifyContent:
                                                          'center',
                                                        '&.Mui-selected, &:hover, &:focus':
                                                          {
                                                            border: '1px solid',
                                                            borderColor:
                                                              currentColor.primary,
                                                            bgcolor:
                                                              currentColor.primary,
                                                            color:
                                                              currentColor.mainbg,
                                                          },
                                                      }}
                                                    >
                                                      <Typography
                                                        sx={{
                                                          fontSize: '10px',
                                                          whiteSpace: 'nowrap',
                                                        }}
                                                      >
                                                        {' '}
                                                        {time?.Time}
                                                      </Typography>
                                                    </ListItemButton>
                                                  )}
                                                </Grid>
                                              );
                                            },
                                          )}
                                      </>
                                    )}
                                  </>
                                )}
                              </Grid>
                            </Box>
                          </Grid>
                        </Box>
                      </>

                      <Box sx={{ mt: 4, mb: 5 }}>
                        <Button
                          variant="contained"
                          fullWidth
                          sx={{ borderRadius: '12px', py: 2 }}
                          disabled={!guest || !date || !selectedTime}
                          onClick={() => {
                            if (true) {
                              navigate(
                                fullyBooked
                                  ? `${guestUrl}waitlist=true`
                                  : `${guestUrl}waitlist=false`,
                              );
                            } else {
                              setActiveStep(1);
                            }
                          }}
                        >
                          Proceed
                        </Button>
                      </Box>
                    </>
                  )}
                  {activeStep === 0 && (
                    <>
                      {foodCards.map((food) => (
                        <div onClick={() => handleClickGift(food)}>
                          <FoodCard
                            index={food.index}
                            price={`₦${food.price.toLocaleString()}`}
                            image={reserved}
                            title={food.title}
                            body={food.body}
                          />
                        </div>
                      ))}
                    </>
                  )}
                </Box>
              </>
            )}
            {IS_TERRACE && (
              <Typography sx={{ textAlign: 'center', mt: 4, color: '#b8b3a5' }}>
                Powered by <img src={logogrey} width={25} /> Reisty
              </Typography>
            )}
          </Box>
        </Box>

        <Popover
          id={pid}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
        >
          <Box>
            <Calender
              future={false}
              past={true}
              onChildValue={(value) => {
                setDate(value);
                setAnchorEl(null);
                
              }}
            />
          </Box>
        </Popover>
      </ThemeProvider>
    </>
  );
};

export default GiftWidget;

const foodCards = [
  {
    index: '01',
    price: 50000,
    image: reserved,
    title: '3 Course Meal',
    body: 'Lorem Ipsum is simply dummy text the printing & typesetting.',
  },
  {
    index: '02',
    price: 500000,
    image: reserved,
    title: 'Brunch Bistro',
    body: 'Lorem Ipsum is simply dummy text the printing & typesetting.',
  },
  {
    index: '03',
    price: 245000,
    image: reserved,
    title: 'Dinner with my Man',
    body: 'Lorem Ipsum is simply dummy text the printing & typesetting.',
  },
];
